import React from 'react'
import './Home.css'
import Product from './Product'

function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img
                    className="home__image"
                    src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg" 
                    alt="Homepage Banner" 
                />

                <div className="home__row">
                    <Product
                        id="1"
                        title="Echo Dot (3rd Generation)"
                        price={3499}
                        image="https://m.media-amazon.com/images/I/61EXU8BuGZL._AC_UY218_.jpg"
                        rating={5} 
                    />
                    <Product
                        id="2"
                        title="LG 4K Smart LED TV"
                        price={53999}
                        image="https://images-na.ssl-images-amazon.com/images/I/81QJ2tzfzmL._SL1500_.jpg"
                        rating={4}
                    />
                </div>

                <div className="home__row">
                    <Product
                        id="3"
                        title="Panasonic 268 L 2 Star 6-Stage Inverter Frost Free Double Door Refrigerator(NR-TBG27VSS3,Shining Silver, Jumbo Vegetable Basket)"
                        price={22990}
                        image="https://images-na.ssl-images-amazon.com/images/I/71R8b57aasL._SL1500_.jpg"
                        rating={5}
                    />
                    <Product
                        id="4"
                        title="OnePlus 8 Pro (Glacial Green 12GB RAM+256GB Storage)"
                        price={59999}
                        image="https://images-na.ssl-images-amazon.com/images/I/61n6Ovq6EdL._SL1500_.jpg"
                        rating={5}
                    />
                    <Product
                        id="5"
                       title="JBL T460BT Extra Bass Wireless On-Ear Headphones with 11 Hours Playtime & Mic (Black)"
                       price={2999}
                       image="https://images-na.ssl-images-amazon.com/images/I/71ynIMjwgwL._SL1500_.jpg"
                       rating={4} 
                    />
                </div>

                <div className="home__row">
                    <Product
                        id="6"
                        title="HP Pavilion 15-cs3006tx 15.6-inch Laptop (10th Gen i5-1035G1/8GB/1TB HDD + 256GB SSD/Windows 10, Home/2 GB Graphics), Mineral Silver"
                        price={79999}
                        image="https://images-na.ssl-images-amazon.com/images/I/71LOolGaCDL._SL1500_.jpg"
                        rating={5}
                    />
                </div>
            </div>
        </div>
    )
}

export default Home
